import { z } from "zod"
import type { TranslateLanguageTypeEnum } from "./translation.types"

// Keep existing enum hints for callers while accepting identities advertised by the service.
// The common catalogue, rather than a static frontend enum, decides whether a pair is usable.
export const LanguageCodeSchema = z.custom<TranslateLanguageTypeEnum>(
  (value) =>
    typeof value === "string" &&
    /^(auto|[a-z]{2,3}(?:-[a-z0-9]+)?)$/.test(value),
  "A language code is required"
)
